module.exports = "query getUserrights{rights{id name description}}"